const selectors = {
    el: '.video-poster:not(.is-ready)',
    video: '.c-video__player ',
    wrapper: '.video-player-wrapper',
    playButton: '.video-poster__play-button',
    closeButton: '.video-player-wrapper__close-icon'
}

const classes = {
    active: 'video-player-wrapper--active'
}

const build = videoPoster => {
    videoPoster.classList.add('is-ready');
    const videoPosterPlayButton = videoPoster.querySelector(selectors.playButton);

    const videoWrapper = videoPoster.parentElement;
    if (!videoWrapper) return;

    const videoWrapperParent = videoWrapper.parentElement;
    if (!videoWrapperParent) return;

    const videoPlayerWrapper = videoWrapperParent.querySelector(selectors.wrapper);
    if (!videoPlayerWrapper) return;

    const video = videoPlayerWrapper.querySelector(selectors.video);
    if (!video) return;
    
    const closeVideo = videoPlayerWrapper.querySelector(selectors.closeButton);

    const eventsTriggers = ['click', 'touchstart', 'touchend'];

    eventsTriggers.forEach((eventTrigger) => {
        // open video player
        videoPoster.addEventListener(eventTrigger, (event) => {
            if (event.target === videoPoster) {
                event.preventDefault();
                openVideoPlayer(videoPlayerWrapper, video);
                video.focus();
            }
        });
        videoPosterPlayButton.addEventListener(eventTrigger, (event) => {
            if (event.target === videoPosterPlayButton) {
                event.preventDefault();
                openVideoPlayer(videoPlayerWrapper, video);
                video.focus();
            }
        });
    
        // close video player
        videoPlayerWrapper.addEventListener(eventTrigger, (event) => {
            if (event.target === videoPlayerWrapper) {
                event.preventDefault();
                closeVideoPlayer(videoPlayerWrapper, video);
            }
        });
        closeVideo.addEventListener(eventTrigger, (event) => {
            if (event.target === closeVideo) {
                event.preventDefault();
                closeVideoPlayer(videoPlayerWrapper, video);
            }
        });
    });
}

const openVideoPlayer = (wrapper, video) => {
    disableScroll();

    wrapper.classList.add(classes.active);
    video.play();
}

const closeVideoPlayer = (wrapper, video) => {
    enableScroll();

    wrapper.classList.remove(classes.active);
    video.pause();
}

const enableScroll = () => {
    document.body.style.overflow = 'auto';
}

const disableScroll = () => {
    document.body.style.overflow = 'hidden';
}

const init = () => {
    const videoPosters = document.querySelectorAll(selectors.el);
    videoPosters.forEach(build);
}

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;